import { Col, Row, Typography } from "antd";
import React from "react";
import { formatDateInMMDDYYYY } from "../../helpers/date";
import DeleteFormulaItem from "../Items/formula-items/DeleteFormulaItem";
import FormulaSwitch from "../Items/formula-items/FormulaSwitch";
import EditIcon from "./../../graphics/svgs/EditIcon.svg";
const FormulaTableRow: React.FC<IFormulaTableRow> = ({
  activeBg,
  formula,
  handleUpdateFormulaStatus,
  deleteFormula,
  handleEditFormula,
}) => {
  return (
    <Row
      style={{ background: activeBg }}
      gutter={[16, 16]}
      className="table-single-row-container"
    >
      <Col className="table-single-cell" span={6}>
        <Typography className="users-table-generic-label">
          {formula.activeIngredients}
        </Typography>
      </Col>
      <Col className="table-single-cell" span={6}>
        <Typography className="users-table-generic-label">
          {formula.creamBase}
        </Typography>
      </Col>
      <Col className="table-single-cell" span={4}>
        <Typography className="users-table-generic-label">
          {formula.orderCount}
        </Typography>
      </Col>

      <Col className="table-single-cell" span={3}>
        <Typography className="users-table-generic-label">
          {formatDateInMMDDYYYY(new Date(formula.createdAt))}
        </Typography>
      </Col>
      <Col className="table-single-cell" span={3}>
        <FormulaSwitch
          _id={formula._id}
          isActive={formula.isActive}
          handleUpdateFormulaStatus={handleUpdateFormulaStatus}
        />
      </Col>

      <Col className="table-cell-hrz" span={2}>
        <img
          onClick={(e) => handleEditFormula(formula)}
          src={EditIcon}
          style={{ width: "25px", cursor: "pointer" }}
        />
        <DeleteFormulaItem _id={formula._id} deleteFormula={deleteFormula} />
      </Col>
    </Row>
  );
};
export default FormulaTableRow;
